


























import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import EntityType from '@/models/Shared/EntityType';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import { ProductIssueDetailsModule } from '@/store/Products/ProductIssueDetailsModule';
import SecondaryWalletsGeneralSettingsEditDialog from '@/components/Products/ProductSettings/SecondaryWallets/General/SecondaryWalletsGeneralSettingsEditDialog.vue';

@Component({ name: 'SecondaryWalletsGeneralSettings', components: { SecondaryWalletsGeneralSettingsEditDialog } })
export default class extends SaascadaVue {

    EntityType = EntityType;

    @Prop({required: true})
    entityType: EntityType;

    get loading() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.loading;
        }
        return ProductIssueDetailsModule.loading;
    }

    get secondaryWalletTypeSettingsAvailable() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.product.secondaryWalletSettings;
        }
        return ProductIssueDetailsModule.productIssue.secondaryWalletSettings;
    }

}
